import { useEffect } from 'react'

import { user } from '@percept/redux/bundles'

import { useDispatch } from 'react-redux'

import {
  APP_BROADCAST_ACTION__SIGN_IN,
  APP_BROADCAST_ACTION__SIGN_OUT,
  appBroadcastChannel,
} from '@percept/constants'

import { get } from 'lodash-es'


export const AppBroadcastChannelListener = (): null => {
  const dispatch = useDispatch()
  useEffect(() => {
    appBroadcastChannel.addEventListener('message', event => {
      const action = get(event.data, 'action')
      switch(action){
        case APP_BROADCAST_ACTION__SIGN_IN:
          dispatch(user.actions.checkRefreshToken())
          break
        case APP_BROADCAST_ACTION__SIGN_OUT:
          dispatch(user.actions.signOut())
          break
        default:
          break
      }
    })
  }, [dispatch])

  return null
}
